var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9688 14.1483H8.59375",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 12.7733H2.40625",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1 12.7733H1.03125",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 10.7108H13.0625",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 10.7108H19.5938C20.3363 10.7108 20.9413 10.1196 20.9688 9.38394C20.9413 7.46582 19.7794 5.74706 18.0056 5.01144L17.7788 4.91519C17.1662 4.65394 16.6231 4.25519 16.1968 3.74644L15.8806 3.36832C14.3138 1.48457 11.99 0.398315 9.5425 0.398315H7.73438C6.12563 0.398315 4.62 1.20269 3.72625 2.54332L3.47188 2.92144C3.22506 3.29957 2.90125 3.62269 2.52313 3.87019L1.64313 4.46144C1.25813 4.71582 1.03125 5.14207 1.03125 5.60269V9.33582C1.03125 9.96213 1.45544 10.4943 2.03087 10.6586",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96883 4.52332H17.0707C16.7476 4.30332 16.4451 4.04894 16.1969 3.74644L15.8806 3.36832C14.3138 1.48457 11.9901 0.398315 9.54258 0.398315H7.73445C6.7307 0.398315 5.7682 0.714566 4.9707 1.27144",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 2.46082L5.52109 2.73582C5.91984 3.81519 6.94353 4.52332 8.09166 4.52332H8.59353",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 10.7108C7.21875 11.8521 6.2975 12.7733 5.15625 12.7733C4.015 12.7733 3.09375 11.8521 3.09375 10.7108C3.09375 9.56957 4.015 8.64832 5.15625 8.64832C6.2975 8.64832 7.21875 9.56957 7.21875 10.7108Z",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 11.3983C5.53595 11.3983 5.84375 11.0905 5.84375 10.7108C5.84375 10.3311 5.53595 10.0233 5.15625 10.0233C4.77655 10.0233 4.46875 10.3311 4.46875 10.7108C4.46875 11.0905 4.77655 11.3983 5.15625 11.3983Z",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 10.7108C18.2188 11.8521 17.2975 12.7733 16.1562 12.7733C15.015 12.7733 14.0938 11.8521 14.0938 10.7108C14.0938 9.56957 15.015 8.64832 16.1562 8.64832C17.2975 8.64832 18.2188 9.56957 18.2188 10.7108Z",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 11.3983C16.5359 11.3983 16.8438 11.0905 16.8438 10.7108C16.8438 10.3311 16.5359 10.0233 16.1562 10.0233C15.7766 10.0233 15.4688 10.3311 15.4688 10.7108C15.4688 11.0905 15.7766 11.3983 16.1562 11.3983Z",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 4.52332H9.96875L9.625 1.42957",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0063 6.58582H17.875L17.9575 6.92269C18.1088 7.53457 18.6587 7.96082 19.2906 7.96082H19.6969",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34919 6.58582H1.03125",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9117 9.33582H19.5938",
    stroke: "white",
    strokeWidth: 0.6875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/حجزاتي.487229027612d30e45865b87c2df8435.svg";
export { ForwardRef as ReactComponent };